import * as fromDatatype from "../datatype-library/index";

export interface bl_sfa_qualification_criteria_field_values_hdr_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	param_code: fromDatatype.VarcharDatatypeInterface;
	value_string: fromDatatype.VarcharDatatypeInterface;
	value_numeric: fromDatatype.NumericDatatypeInterface;
	order_criteria: fromDatatype.IntegerDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_sfa_qualification_criteria_field_values_hdr_RowClass
	implements bl_sfa_qualification_criteria_field_values_hdr_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	qualification_criteria_guid: fromDatatype.GuidDataFieldInterface;
	namespace: fromDatatype.VarcharDatatypeInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	param_code: fromDatatype.VarcharDatatypeInterface;
	value_string: fromDatatype.VarcharDatatypeInterface;
	value_numeric: fromDatatype.NumericDatatypeInterface;
	order_criteria: fromDatatype.IntegerDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
